import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { DialogTitleWithClose } from '../../../common';
import PropTypes from 'prop-types';

/**
 * DialogHeader Component
 * Header for template feedback dialog with refresh button
 */
const DialogHeader = ({
  template,
  loading,
  onRefresh,
  onClose,
  disableClose = false,
}) => {
  return (
    <DialogTitleWithClose
      title={
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="h6">
                Feedback -{' '}
                {template?.template_name || template?.name || 'Template'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Template ID: {template?.template_id || template?.id}
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={onRefresh}
              disabled={loading}
              sx={{ mr: 6 }}
            >
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>
      }
      onClose={onClose}
      disableClose={disableClose || loading}
    />
  );
};

DialogHeader.propTypes = {
  template: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  disableClose: PropTypes.bool,
};

export default DialogHeader;
